<template>
  <div class="content content-depotfinder">
    <div class="content__inner">
      <div class="wrapper">
        <BackButton @click="handleBack('/depotfinder')" />

        <NextArrowButton :nextStep="nextStep" />

        <Depositmodels />

        <div class="depotfinder__question text-centered">
          <UiHeadline
            tag="h1"
            size="large"
            theme="primary"
            align="center"
            class="depotfinder__headline"
          >
            {{ $t("depotfinder.orders.headline") }}
          </UiHeadline>

          <OrdersSelect />

          <NextButton :nextStep="nextStep" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UiHeadline from "./../../components/Ui/Headline.vue";
import Depositmodels from "./../../components/DepositModels.vue";
import BackButton from "./../../components/BackButton.vue";
import NextButton from "./../../components/NextButton.vue";
import NextArrowButton from "./../../components/NextArrowButton.vue";
import OrdersSelect from "./../../components/OrdersSelect.vue";
import { backButtonMixin } from "./../../mixins/handleBackButton";

export default {
  mixins: [backButtonMixin],
  components: {
    Depositmodels,
    BackButton,
    NextButton,
    NextArrowButton,
    OrdersSelect,
    UiHeadline
  },
  computed: {
    recommendedDeposit() {
      return this.$store.getters.getRecommendedDeposit;
    },
    nextStep() {
      let nextStep = "";
      // User chose option "online"
      if (this.$store.getters.getOrdersState == "online") {
        nextStep = "depotfinder.results";
        this.setRecommendedDeposit("DepotDirekt");
      } else if (this.$store.getters.getOrdersState != "") {
        nextStep = "depotfinder.assets";
        this.setRecommendedDeposit("");
      }
      return nextStep;
    }
  },
  methods: {
    setRecommendedDeposit(value) {
      this.$store.dispatch("updateRecommendedDeposit", value);
    },
    goToNextStep() {
      this.$router.push({ name: this.nextStep });
    }
  },
  mounted() {
    this.setRecommendedDeposit("");
  }
};
</script>
